import { DetailBadge } from "@/features/ui/detail/DetailBadge";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import { Space } from "@mantine/core";
import { PurchaseOrderCategoriesGet200Response } from "@sizlcorp/sizl-api-document/dist/models";
import { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";

const DetailPurchaseOrderCategory = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Badge: DetailBadge,
  Content: DetailContent,
});

interface PurchaseOrderCategoryDetailHeaderProps {
  data: AxiosResponse<PurchaseOrderCategoriesGet200Response, any[]> | undefined;
}

export const PurchaseOrderCategoryDetailHeader = (
  params: PurchaseOrderCategoryDetailHeaderProps,
) => {
  const { data } = params;
  const { t } = useTranslation();
  const purchaseOrderCategory = data?.data?.rows && data?.data?.rows[0];

  return (
    <DetailPurchaseOrderCategory>
      <DetailPurchaseOrderCategory.Title>
        {`[${t("common.detail", { item: `${t("purchaseOrderCategory.category")}` })}]`}
      </DetailPurchaseOrderCategory.Title>
      <Space h={8} />
      <DetailPurchaseOrderCategory.Field>
        <DetailPurchaseOrderCategory.Label>
          {t("purchaseOrderCategory.name")}
        </DetailPurchaseOrderCategory.Label>
        <DetailPurchaseOrderCategory.Content>
          {purchaseOrderCategory?.name}
        </DetailPurchaseOrderCategory.Content>
      </DetailPurchaseOrderCategory.Field>
    </DetailPurchaseOrderCategory>
  );
};
